var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[_c('div',{staticClass:"search"},[_c('router-link',{attrs:{"to":{name: 'add-agency-auth'}}},[_c('Button',{attrs:{"type":"primary","icon":"ios-add"}},[_vm._v("添加菜单")])],1)],1),_c('div',{staticClass:"table"},[_c('Table',{attrs:{"border":"","columns":_vm.diyData.columns,"data":_vm.apiData.apiAccessList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }